import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({

});

const mapDispatchToProps = (dispatch: any) => ({});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect;
